export default {
  "en": {
    "survey": {
      "actions": {
        "add": "Add new",
        "close": "Close",
        "create": "Create",
        "delete": "Delete",
        "deleteCount": "You are about to delete {count} survey. Are you sure? | You are about to delete {count} surveys. Are you sure?",
        "deleteMultiple": "Delete...",
        "delete_cancel": "Cancel",
        "delete_surveys": "Delete survey | Delete surveys",
        "newSurvey": "New Survey",
        "publish": "Publish",
        "publishCustomer": "Publish for customers",
        "save": "Save",
        "selectAll": "Select all {total} surveys",
        "submit": "Submit",
        "surveys_collapse": "Collapse surveys",
        "surveys_expand": "Expand surveys",
        "unSelectAll": "Clear selection.",
        "unpublish": "Unpublish"
      },
      "attributes": {
        "description": "Internal title",
        "title": "Your question"
      },
      "labels": {
        "NPSOverview": "NPS Overview",
        "NPSQuestion": "How likely are you to recommend {name} to a friend or colleague?",
        "addQuestion": "Add question",
        "allUnitsAssigned": "All units assigned",
        "answer_later": "Answer later",
        "answeredAt": "Answered at",
        "average_score": "Average score",
        "clientTeam": "The {name} Team",
        "comments": "Comments or suggestions? (optional)",
        "completedTime": "Date",
        "customer": "Customer",
        "customer_status": "Status",
        "detractors": "Detractors",
        "dissatisfied": "Dissatisfied",
        "extremelyLikely": "Extremely likely",
        "lets_go": "Let's go",
        "list": "List",
        "neither_satisfied_nor_dissatisfied": "Neither satisfied nor dissatisfied",
        "neutrals": "Neutrals",
        "noSurveyFeedback": "No comments or suggestions",
        "noUnitsClick": "No units yet, click here to add",
        "no_opinion": "No opinion",
        "notAtAllLikely": "Not at all likely",
        "nps": "NPS",
        "numberAnswered": "{answered} out of {total} responses",
        "obligatory": "Make survey obligatory for customers",
        "pendingSurveys": " 1 survey to answer | {count} surveys to answer",
        "promoters": "Promoters",
        "publishNow?": "Publish now?",
        "publishedCount": "Publish this survey to customer | Publish {count} surveys to customers",
        "question": "Question",
        "question_number": "Question {current_number} of {total_questions}",
        "questions": "Questions",
        "respondents": "No respondents | 1 respondent | {count} respondents",
        "response": "Response",
        "responses": "Responses",
        "satisfied": "Satisfied",
        "saveExplainer": "Make this survey visible for your customers? Or save and publish later?",
        "scoreBreakdown": "Score breakdown",
        "selectOneUnit": "Select at least 1 survey",
        "selectUnits": "Select units",
        "selected": "{selected} survey is selected. | {selected} surveys are selected.",
        "showSurveysFor": "Show surveys for",
        "showingResultsFor": "Showing results for",
        "step2Subtitle": "So your customers know what the purpose is of this survey",
        "step2Title": "Add a short introduction",
        "step3Subtitle": "Select your project to include all your units at once.",
        "step3Title": "For which units would you like to create this survey?",
        "survey": "Survey",
        "surveyAlreadyAnswered": "Survey has already been answered. Thank you for your feedback.",
        "surveyAnswer": "Feedback",
        "surveyNotCompleted": "Survey is not completed yet.",
        "surveys": "Surveys",
        "surveysCount": "{count} survey | {count} surveys",
        "thankYou": "Thank you for your feedback!",
        "title": "Question",
        "titles_must_be_unique": "There are duplicate questions. Questions must be unique!",
        "totalSelected": "All {total} surveys are selected.",
        "unit": "Unit",
        "unitSelected": "No unit selected yet | One unit selected | {count} units selected",
        "units": "Units",
        "unitsWithoutSurvey": "{count} unit without a survey | {count} units without a survey",
        "unpublishedCount": "Unpublish this survey | Unpublish {count} surveys",
        "very_dissatisfied": "Very dissatisfied",
        "very_satisfied": "Very satisfied",
        "visibility": "Visibility",
        "yourQuestion": "Your Question"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Ask your customers for feedback",
            "title": "Create your first Survey"
          },
          "none": {
            "subtitle": "Ask your customers for feedback",
            "title": "No surveys found"
          }
        }
      },
      "toasts": {
        "bulk_create": "Survey successfully created | Surveys successfully created",
        "bulk_delete": "Survey successfully deleted | Surveys successfully deleted",
        "bulk_update": "Survey successfully updated | Surveys successfully updated",
        "update": "Survey successfully updated"
      },
      "validation": {
        "needName": "Enter a question",
        "selectUnit": "Select at least 1 unit"
      }
    }
  }
}